import * as React from 'react';

function SvgSpringMinus6(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.902 24.825v6.13L12.85 36.71l20.104 11.509L12.85 59.728l20.104 11.509L12.85 82.746l20.104 11.509-20.104 11.509 20.104 11.509-20.104 11.509 20.104 11.509-20.104 11.51 20.104 11.509-10.052 5.754v6.13"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M20.403 221.631v3.231l-17.278 4.334 20.102 5.042-20.102 5.044 20.104 5.044-20.104 5.043 20.102 5.042-20.102 5.044 20.104 5.043-20.104 5.044 20.102 5.042-20.102 5.043 20.104 5.044-2.826.709v6.856h5v-3.231l17.277-4.334-20.106-5.044 20.106-5.043-20.104-5.042 20.104-5.044-20.106-5.043 20.106-5.044-20.104-5.042 20.104-5.043-20.106-5.044 20.106-5.044-20.104-5.042 2.827-.709v-6.856h-5z"
        fill={props.springcolor}
      />
      <path
        d="M34.435 0h-23v23h23V0zM34.435 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringMinus6;
